(function ($) {
$('a').each(function () {
  if (location.hostname === this.hostname || 'wilate.com' === this.hostname || !this.hostname.length) {
    $(this).addClass('local');
  } else {
    $(this).addClass('external');
  }
});

$('a.external').click(function (e) {

  e.preventDefault();
  console.log("extern clicked");

  $('#exampleModalCenter').addClass('show');

  var target = $(this).attr('target');
  var uri = $(this).attr('href');

  console.log("target, uri:", target, uri);

  $('#exampleModalCenter button.btn-primary').unbind();
  $('#exampleModalCenter button.btn-primary').click(function (e) {

    var link = document.createElement('a');
    link.href = uri;
    link.target = target;
    document.body.appendChild(link);
    link.click();

    $('#exampleModalCenter').removeClass('show');

    return true;

  });

  $('#exampleModalCenter button.btn-secondary').unbind();
  $('#exampleModalCenter button.btn-secondary').click(function (e) {

    $('#exampleModalCenter').removeClass('show');

    return true;

  });

});

})(jQuery);